import { Reveal, Eyebrow } from "@/components/Reveal";

const STEPS = [
  { n: "01", title: "Consultation", desc: "A free call to understand your business, goals and budget." },
  { n: "02", title: "Requirements", desc: "A written scope, timeline and fixed quote you approve before work starts." },
  { n: "03", title: "Design & Development", desc: "We design and build in milestones, sharing progress as we go." },
  { n: "04", title: "Client Review", desc: "You review the site and we apply your revision rounds." },
  { n: "05", title: "Launch", desc: "We deploy, connect your domain and hand over full access." },
  { n: "06", title: "Ongoing Maintenance", desc: "Optional monthly care keeps your site secure, fast and current." },
];

export default function Process() {
  return (
    <section id="process" className="bg-[#070B16] py-24 lg:py-32" data-testid="process-section">
      <div className="mx-auto max-w-7xl px-6">
        <Reveal className="mx-auto max-w-3xl text-center">
          <Eyebrow>Our Process</Eyebrow>
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
            Six steps. Zero surprises.
          </h2>
          <p className="mt-5 text-base text-slate-400 sm:text-lg">
            You always know what happens next, what it costs, and when it ships.
          </p>
        </Reveal>

        <div className="relative mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-6 lg:gap-6">
          <div className="absolute left-0 right-0 top-7 hidden h-px bg-white/10 lg:block" aria-hidden="true" />
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.1}>
              <div data-testid={`process-step-${s.n}`} className="relative">
                <div className="relative z-10 mb-5 inline-flex h-14 w-14 items-center justify-center rounded-2xl border border-[#00F0FF]/30 bg-[#0A0F1C] font-display text-lg font-black text-[#00F0FF]">
                  {s.n}
                </div>
                <h3 className="font-display text-base font-bold text-white">{s.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-slate-400">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
